import { render } from "./OrderPage.vue?vue&type=template&id=47d00e16&ts=true"
import script from "./OrderPage.vue?vue&type=script&lang=ts"
export * from "./OrderPage.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./OrderPage.vue?vue&type=style&index=0&id=47d00e16&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__